
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import CookieConsent from '@/components/common/CookieConsent/CookieConsent';
import 'react-quill/dist/quill.snow.css';
import '@/styles/globals.css';
import type { AppProps } from 'next/app';
import * as React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { GoogleAnalytics } from '@next/third-parties/google';
import { SessionProvider } from 'next-auth/react';
import InitialLoadingScreen from '@/components/common/InitialLoadingScreen';
import Script from 'next/script';
const MyApp = ({ Component, pageProps: { session, ...pageProps } }: AppProps) => {
    const AnyComponent = Component as any; // work araound @types/react
    const [initialLoading, setInitialLoading] = React.useState(true);
    React.useEffect(() => {
        const timer = setTimeout(() => {
            setInitialLoading(false);
        }, 1000);
        const handleLoad = () => {
            setTimeout(() => {
                setInitialLoading(false);
            }, 500);
        };
        if (document.readyState === 'complete') {
            handleLoad();
        }
        else {
            window.addEventListener('load', handleLoad);
        }
        return () => {
            clearTimeout(timer);
            window.removeEventListener('load', handleLoad);
        };
    }, []);
    return (<SessionProvider session={session}>
			<>
				{initialLoading && <InitialLoadingScreen />}
				<ToastContainer />
				<CookieConsent />
				<AnyComponent {...pageProps}/>
				{process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID && (<GoogleAnalytics gaId={process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID}/>)}{' '}
				<Script id="tawk-to" strategy="afterInteractive" src="https://embed.tawk.to/67dd4431f88e1b1912c49c2a/1ims54on8"/>
			</>
		</SessionProvider>);
};
const __Next_Translate__Page__19720e241ab__ = MyApp;

    export default __appWithI18n(__Next_Translate__Page__19720e241ab__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: true,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  